module.exports = function getResource(label, vars = []) {
    let resources = {
        placeholderUs: 'Enter ZIP/Postal code',
        placeholderCa: 'Enter Postal code',
        placeholderOnline: 'Only available online',
        messageEmpty: 'Invalid zip or postal code.',
        messageInvalid: 'Invalid ZIP/Postal code.'
    };
    return resources[label];
};
